import { useSelector } from 'react-redux';
import {
  SHOW_CONFIGURATIONS_MENU,
  SHOW_SCHEDULED_TASKS_MENU,
  SHOW_USER_PREFERENCES_TAB,
} from '../modules/permissions/permission.type';
import { isAllowedTo } from '../modules/permissions/permission.util';
import { userHasGroup } from '../utils/utils';
import { Country } from '../utils/constants/values.constants';

const NoAccess = () => {
  return (
    <div className="d-flex flex-column justify-content-center unAuthriseContent">
      <div>
        <i
          style={{ fontSize: '64px' }}
          className="text-danger k-icon k-i-lock"
        ></i>
      </div>
      <h3 className="mt-3 text-danger">Unauthorized Access</h3>
      <p className="lead">
        You are trying to access a page for which you are not authorized, please
        contact administrator
      </p>
    </div>
  );
};

const AuthorizationRoute = ({ path, LoadedComponent }) => {
  const uiPermissions = useSelector(
    (state) => state.inventoryManagementReducer?.uiRulesData?.uiPermissions
  );
  const {
    inventoryMenu,
    logisticMenu,
    bigDealerMenu,
    crudDriver,
    userManagementMenu,
    masterdataMenu,
    bulkUpload,
    documentsMenu,
    carCleaningQa,
    carCleaningHistory,
    trainingTutorials,
  } = uiPermissions || {};

  if (path.includes('/inventory') && (inventoryMenu ?? true))
    return LoadedComponent();
  if (path.includes('/logistic') && (logisticMenu ?? true))
    return LoadedComponent();
  if (
    path.includes('/scheduled-tasks') &&
    isAllowedTo(SHOW_SCHEDULED_TASKS_MENU)
  )
    return LoadedComponent();
  if (path.includes('/big-dealer') && (bigDealerMenu ?? true))
    return LoadedComponent();
  if (path.includes('/driver') && (crudDriver ?? true))
    return LoadedComponent();
  // if (path.includes('/user-management') && (userManagementMenu ?? true))
  //   return LoadedComponent();
  if (path.includes('/ums') && (userManagementMenu ?? true))
    return LoadedComponent();
  if (
    path.includes('/user-preferences') &&
    isAllowedTo(SHOW_USER_PREFERENCES_TAB) &&
    userHasGroup(['CC_ADMIN'])
  )
    return LoadedComponent();
  if (
    path.includes('/user-preferences/dnd') &&
    isAllowedTo(SHOW_USER_PREFERENCES_TAB) &&
    userHasGroup(['CC_ADMIN'])
  )
    return LoadedComponent();
  if (path.includes('/location') && (masterdataMenu ?? true))
    return LoadedComponent();
  if (path.includes('/masterdata') && (masterdataMenu ?? true))
    return LoadedComponent();
  if (path.includes('/bulk-upload-v2') && (bulkUpload ?? true))
    return LoadedComponent();
  if (path.includes('/document-pendency') && (documentsMenu ?? true))
    return LoadedComponent();
  if (path.includes('/key-management')) return LoadedComponent();
  if (path.includes('/configs') && isAllowedTo(SHOW_CONFIGURATIONS_MENU))
    return LoadedComponent();
  if (path.includes('/fastag') && true) return LoadedComponent();
  if (path.includes('/car-cleaning-qa') && (carCleaningQa ?? true))
    return LoadedComponent();
  if (path.includes('/car-cleaning-history') && (carCleaningHistory ?? true))
    return LoadedComponent();
  if (path.includes('/training-tutorials') && (trainingTutorials ?? true))
    return LoadedComponent();
  if (
    path.includes('/enbd-rstl') &&
    userHasGroup(['DRAWDOWN_ADMIN']) &&
    localStorage.getItem('country') === Country.AE
  )
    return LoadedComponent();
  if (
    path.includes('/coupon-requests') &&
    userHasGroup(['UAE_CPN_REQ', 'UAE_CPN_APPR']) &&
    localStorage.getItem('country') === Country.AE
  )
    return LoadedComponent();
  if (
    path.includes('/coupon-config-management') &&
    userHasGroup(['UAE_CPN_APPR']) &&
    localStorage.getItem('country') === Country.AE
  )
    return LoadedComponent();

  return <NoAccess />;
};

export default AuthorizationRoute;
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
